import {Component, OnInit, ViewChild} from '@angular/core';
import {
	PhoneNumberRecoveryComponent
} from "@app/channels/auth/login/partials/forget-passcode/partials/phone-number-recovery/phone-number-recovery.component";
import {FormBuilder} from "@angular/forms";
import {SettingsService} from "@mpt-fo/common/core/services/settings.service";
import {
	KamonaPhoneNumberFieldComponent
} from "@mpt-fo/common/kamona/components/kamona-phone-number-field/kamona-phone-number-field.component";

@Component({
  selector: 'app-web-phone-number-recovery',
  templateUrl: './web-phone-number-recovery.component.html',
  styleUrls: ['./web-phone-number-recovery.component.scss']
})
export class WebPhoneNumberRecoveryComponent extends PhoneNumberRecoveryComponent implements OnInit {
	constructor(fb: FormBuilder, settingsService: SettingsService) {
		super(fb, settingsService);
	}

	ngOnInit(): void {
		this.initialize();
	}

}
